import * as THREE from '../../three.module';
import {OrbitControls} from '../../OrbitControls.js';
import {TransformControls} from '../../TransformControls.js';
import {DragControls} from '../../DragControls';

let isActiveLight = false;

let lightControllerContainer, labelIntensity, inputIntensity, labelColor, inputColor, darkColor,
    lightColor, threeCanvas, intensityPoints;

const initContainers = () => {
  isActiveLight = false;

  lightControllerContainer = document.createElement('div');
  lightControllerContainer.className = 'light-controller-container';
  lightControllerContainer.style.position = 'absolute';
  lightControllerContainer.style.display = 'none';
  lightControllerContainer.style.top = '10px';
  lightControllerContainer.style.left = '10px';
  lightControllerContainer.style.height = '350px';
  lightControllerContainer.style.width = '200px';
  lightControllerContainer.style.background = 'rgba(255, 255, 255, 0.7)';
  lightControllerContainer.style.padding = '5px';

  labelIntensity = document.createElement('label');
  labelIntensity.innerHTML = 'Яркость';

  inputIntensity = document.createElement('input');
  inputIntensity.type = 'range';
  inputIntensity.min = 0;
  inputIntensity.max = 2;
  inputIntensity.step = 0.4;
  inputIntensity.value = 0.8;
  inputIntensity.style.width = 'calc(100% - 20px)';
  inputIntensity.className = 'intensity-range';
  intensityPoints = document.createElement('div');
  let point = document.createElement('span');
  point.innerText = '   ';
  let point1 = document.createElement('span');
  point1.innerText = '  1';
  let point2 = document.createElement('span');
  point2.innerText = '  2';
  let point3 = document.createElement('span');
  point3.innerText = '3';
  let point4 = document.createElement('span');
  point4.innerText = '4';
  let point6 = document.createElement('span');
  point6.innerText = '   ';
  intensityPoints.style.display = 'flex';
  intensityPoints.style.justifyContent = 'space-between';
  intensityPoints.style.width = 'calc(100% - 44px)';
  intensityPoints.style.marginLeft = '16px';
  intensityPoints.style.height = '13px';
  intensityPoints.append(point);
  intensityPoints.append(point1);
  intensityPoints.append(point2);
  intensityPoints.append(point3);
  intensityPoints.append(point4);
  intensityPoints.append(point6);

  labelColor = document.createElement('label');
  labelColor.innerHTML = 'Цвет';
  inputColor = document.createElement('input');
  inputColor.type = 'range';
  inputColor.min = 0;
  inputColor.max = 4;
  inputColor.step = 1;
  inputColor.value = 0;
  inputColor.style.width = 'calc(100% - 20px)';
  inputColor.className = 'color-range';
  darkColor = document.createElement('div');
  darkColor.style.borderRadius = '50px';
  darkColor.style.width = '10px';
  darkColor.style.height = '10px';
  darkColor.style.marginLeft = '3px';
  darkColor.style.backgroundColor = '#0000ff';


  lightColor = document.createElement('div');
  lightColor.style.borderRadius = '50px';
  lightColor.style.width = '10px';
  lightColor.style.height = '10px';
  lightColor.style.float = 'right';
  lightColor.style.backgroundColor = '#ffff00';
  lightColor.style.position = 'relative';
  lightColor.style.top = '-11px';
  lightColor.style.right = '18px';


  threeCanvas = document.createElement('div');
  threeCanvas.style.width = '180px';
  threeCanvas.style.height = '180px';
};

const colors = [
  [248, 248, 248],
  [248, 248, 186],
  [248, 248, 124],
  [248, 248, 62],
  [248, 248, 0]
];


const boxHeight = 180;
const boxWidth = 180;
const limits = {
  y: [-70, 70],
  x: [-70, 70],
  z: [0, 0]
};

export function setIsActiveLight(value) {
  lightControllerContainer.style.display = value ? 'block' : 'none';
  isActiveLight = value;
}

export function getIsActiveLight() {
  return isActiveLight;
}

export function createLightController(container, light, options) {
  initContainers();
  lightControllerContainer.append(threeCanvas);
  labelIntensity.innerHTML = options.textIntensityLabel || labelIntensity.innerHTML;
  lightControllerContainer.append(labelIntensity);
  lightControllerContainer.append(intensityPoints);
  lightControllerContainer.append(inputIntensity);
  labelColor.innerHTML = options.textColorLabel || labelColor.innerHTML;
  lightControllerContainer.append(labelColor);
  lightControllerContainer.append(inputColor);
  lightControllerContainer.append(darkColor);
  lightControllerContainer.append(lightColor);
  initThree(threeCanvas, light);
  container.append(lightControllerContainer);
}

function initThree(container, light) {
  const scene = new THREE.Scene();
  const camera = new THREE.PerspectiveCamera(50, 1, 1, 1000);
  camera.position.set(0, 0, boxWidth * 1.7);
  scene.add(new THREE.AmbientLight(0x666666));
  const renderer = new THREE.WebGLRenderer({antialias: true, alpha: true});
  renderer.setClearColor(0x000000, 0);
  renderer.setPixelRatio(window.devicePixelRatio);
  renderer.setSize(parseInt(container.style.width), parseInt(container.style.height));
  container.appendChild(renderer.domElement);

  const lineSegments = new THREE.LineSegments();
  const edgesGeometry = new THREE.EdgesGeometry(new THREE.BoxGeometry(boxWidth, boxHeight, 0));
  const lineBasicMaterial = new THREE.LineBasicMaterial({color: '#858789', linewidth: 2});
  lineSegments.geometry = edgesGeometry;
  lineSegments.material = lineBasicMaterial;

  scene.add(lineSegments);

  const lightMesh = new THREE.Mesh();
  let isLoaded;
  let texture = new THREE.TextureLoader().load(
    'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAAgCAYAAADjaQM7AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAMsSURBVHgBzVfBTttAEJ21vb1VMuLSWy2RRNwg6gc0+YPwBSSFA7fSLwC+gHCr1ALhCxqOPQH3qqTnGOH+AIT2hteeziy2ZOJNbEet1CdFXq9nd3Zm37zdCKiAndVVL4zjC0AEGYbtj0EQVBlvlTXcWlnpqCj6Qo48evVCKS+4DypAlDHqep5rS3lv+haF4dIgCCbwv6FUZDpdlvXe+DGOB8c3N2dQAg6UBZFiBh6gJHKR7dL+/JZyk9h2XpVtzNZHpTZjpY5M+5iL7JeUHVpBn9i2S8Ro8qB39XqX+k5NDhBx/8T3D7jNZSGE8IhM7Oho2jZH/TgMhyhEQE3PkXIPSmK70djnsqBkB8TQc5NNzhlHYsVxT6+assq0J6O12W7A1baIemEijj8MZqR/Jht16uIYpZRXYRRdp5MaMKH9bT5K2WL7ecwspP5WvX5Bj1aB2eXxeNwusAGb2bfuuq++TSY59uh9IAGBYnhvlpfd73d3X6c/ZOcXW43GbbKxI0pDP02DFt0ouoUKEIjtz75/yW3KCIsAa2eLfhOKfMmijR1qQ4B1UokBqcUmv5OjU6gIYrEmSSLQfUjTjzhKfFCeKAorilrUucYFSaRwY4BrWAAcnVJqZDnOHtUcl8FZWuBGgiQp6MNi2KWUHZk+GM8zSu0smhdi3lijMwr/n5xPz5zteJ6nnSH+gAVhJWRI58pCbNdqLWIRM5AZ5Kb0pX3jk7lSOlkXSVubjuOs05wsBpyhIc15xnNaSWeXJybjCTEp0AMRD6AqEAfMPOU4QSLmvNhu4gMEMw+finp46vtX2bElpSqNanQyHjezfb1a7S3RvcMlwAydq41a8aU8FEWShXgZKbVRdPGZe5XjwbTaHq26xxOanNAdZOPY99tlNtcYmb4avHhxzfcOUoBmumKOFKT0bKXuI8SHbCSJxj6zLxUZ3UEOE3GG7EBuu2EYvJxypIN8eni248zU1JyzRES73CYa584ojpgWk9NNG3EDmOpCdFIxL3TG6sHM4ouM8XhPrt/T3Z/GYx5zwOVDc/yEvwEqB+QfLIDSfywyWFg3y9+IE0S23RRKvYYF8AcDxaxN597ZiwAAAABJRU5ErkJggg==',
    function (texture) {
      isLoaded = true;
    }, function (xhr) {
      isLoaded = false;
  });
  let lightBufferGeometry;
  let lightMeshMaterial;
  setTimeout(() => {
    if (!isLoaded) {
      lightMeshMaterial = new THREE.MeshBasicMaterial({
        color: '#632525'
      });
      lightBufferGeometry = new THREE.SphereBufferGeometry(15, 32, 32);
    } else {
      lightMeshMaterial = new THREE.MeshBasicMaterial({map: texture});
      lightBufferGeometry = new THREE.BoxBufferGeometry(32, 32, 0);
    }
    lightMesh.material = lightMeshMaterial;
    lightMesh.geometry = lightBufferGeometry;
    // lightMesh.position.set(light.position.x, 70, light.position.z);
    lightMesh.position.set(15, -30, 0);
    transformControlsChange();
    scene.add(lightMesh);
  }, 500);




  const transformControls = new TransformControls( camera, renderer.domElement );
  transformControls.setSize(2);
  transformControls.showY = true;
  transformControls.showZ = true;
  const transformControlsChange = (event) => {
    const position = lightMesh.position;

    if (position.y < (limits.y[0])) {
      position.y = limits.y[0];
    }
    if (position.y > limits.y[1]) {
      position.y = limits.y[1];
    }
    if (position.x < (limits.x[0])) {
      position.x = limits.x[0];
    }
    if (position.x > limits.x[1]) {
      position.x = limits.x[1];
    }
    if (position.z < (limits.z[0])) {
      position.z = limits.z[0];
    }
    if (position.z > limits.z[1]) {
      position.z = limits.z[1];
    }
    if (position.x >= limits.x[0] && position.x <= limits.x[1]) {
      if (position.y === limits.y[0] || position.y === limits.y[1]) {
        if (position.z === limits.z[0] || position.z === limits.z[1]) {
          transformControls.showY = position.z !== limits.z[0];
        } else {
          transformControls.showY = position.x === limits.x[0] || position.x === limits.x[1];
          transformControls.showX = true;
        }
      } else {
        if (position.x === limits.x[0] || position.x === limits.x[1]) {
          transformControls.showX = position.z === limits.z[0] || position.z === limits.z[1];
        } else {
          transformControls.showX = true;
        }
      }
    }
    light.position.set(lightMesh.position.x, 70, lightMesh.position.y);
    renderer.render(scene, camera);
  };

  let dragControls = new DragControls([lightMesh], camera, renderer.domElement);
  dragControls.addEventListener('drag', transformControlsChange);
  transformControlsChange();

  // transformControls.addEventListener("change", transformControlsChange);
  //
  // transformControls.attach(lightMesh);
  // scene.add(transformControls);


  const controls = new OrbitControls(camera, renderer.domElement);
  controls.enableRotate = false;
  controls.enableZoom = false;
  controls.enablePan = false;

  inputIntensity.addEventListener('input', (event) => {
    light.intensity = +event.target.value
  });

  inputColor.addEventListener('input', (event) => {
    const value = +event.target.value;
    light.color = new THREE.Color(colors[value][0] / 255, colors[value][1] / 255, colors[value][2] / 255);
  });

  const animate = function animate(now) {
    requestAnimationFrame(animate);
    renderer.render(scene, camera);
    controls.update();
  };

  animate();
}
